<template>
  <div id="v-nodata">
    <v-card style="padding: 10px" flat>
      <v-card-text v-if="!loading">
        <slot name="nodata-content">
          <!-- <v-icon  :size="80">{{icon}}</v-icon> -->
          <v-img
            v-if="!networkError"
            :src="getImage"
            class="mb-3"
            style="max-height:200px"
            contain
            height="200"
          ></v-img>

          <v-img
            v-else
            :src="noNetworkImage"
            class="mb-3"
            style="max-height:200px"
            contain
            height="200"
          ></v-img>

          <h4 v-if="!networkError" style="font-size: 17px; opacity: 0.7; font-weight: 500">
            {{ msgDetails }}
          </h4>
          <h4 v-else style="font-size: 17px; opacity: 0.7; font-weight: 500">
            No Records or Network Error
          </h4>
          <div style="padding: 10px; margin-top: 15px">
            <v-btn v-if="networkError" @click="retry" color="primary" tile>
              <v-icon :size="22" icon style="margin-right: 5px">refresh</v-icon>Retry</v-btn
            >
          </div>
        </slot>
      </v-card-text>
      <v-card-text v-else>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
const noNetworkImage = require("@/assets/checkinguy.png");

export default {
  name: "VNodata",
  props: {
    title: {
      type: String
    },
    msgDetails: {
      type: String
    },
    enableHeader: {
      type: Boolean,
      default: false
    },
    networkError: {
      type: Boolean,
      default: false
    },
    contentBg: {
      type: String,
      default: "white"
    },
    loading: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String
    }
  },

  data() {
    return {
      noNetworkImage: noNetworkImage
    };
  },
  computed: {
    getImage() {
      return require(`@/assets/${this.icon}.png`);
    }
  },
  mounted() {},
  created() {},

  methods: {
    retry() {
      this.$emit("retryMethod", true);
    }
  }
};
</script>
